// AboutPage.tsx

import React, { useEffect, useRef } from "react";
import CompanyImage from "../../../assets/logo.png"; // Import your company image
import { SelectedPage } from "../../../shared/types";
import { NavLink } from "react-router-dom";
import "./AboutPage.css";

type Props = {
  setSelectedPage(value: SelectedPage): void;
};

function AboutPage({ setSelectedPage }: Props) {
  const aboutRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (aboutRef.current) {
        const rect = aboutRef.current.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight - 100;

        if (isVisible) {
          aboutRef.current.classList.add("about-enter-active");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Call it once to check initial visibility

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div ref={aboutRef} className="container mx-auto mt-8 p-8 about-enter">
      <h2 className="text-3xl lg:text-5xl font-bold text-center text-palette1 mb-6">
        About Us
      </h2>

      <div className="flex flex-col sm:flex-row items-center justify-center mb-8">
        <img
          src={CompanyImage}
          alt="Company Image"
          className="rounded-full h-48 w-48 object-contain mr-4"
        />
        <p className="text-lg lg:text-xl 2xl:text-2xl text-palette3 mt-4 sm:mt-0  text-center sm:text-justify">
          Established in 2013, Dream Innovation is a dynamic Small Enterprise at
          the forefront of aerospace and automotive research and development.
          Our multidisciplinary team, consisting of both young innovators and
          seasoned professionals, specializes in fluid dynamics simulations,
          advanced mechanical design, and cutting-edge materials. We have a
          successful history of collaborating with European industry leaders,
          providing strategic advisory services, management consulting, and
          winning research proposals at various levels.
        </p>
      </div>

      <p className="text-lg lg:text-xl 2xl:text-2xl text-palette3 text-center sm:text-justify">
        Dream Innovation stands as your trusted partner for high-value
        technological solutions and business growth strategies. With a proven
        track record, we offer unparalleled expertise in aerospace and
        automotive sectors. Whether you require strategic advice or aim to
        develop a technological diversification strategy, our team is committed
        to supporting your journey with precision and innovation.
      </p>

      {/* Read More button */}
      <div className="flex items-center justify-center mt-4">
        <NavLink
          to={`/about`}
          onClick={() => {
            setSelectedPage(SelectedPage.About);
          }}
        >
          <button className="mt-4 bg-palette border  border-palette3 text-palette3 px-4 py-2 rounded hover:bg-palette3 hover:text-palette5 transition-colors">
            Read More
          </button>
        </NavLink>
      </div>
    </div>
  );
}

export default AboutPage;
